export default "__VITE_ASSET__a30df5a7__"